export default function removeEmptyAttrFromObj(obj) {
  Object.keys(obj).forEach(
    (key) =>
      (obj[key] && typeof obj[key] === 'object') ||
      ((obj[key] === '' || obj[key] === null || typeof obj[key] === 'undefined') &&
        // eslint-disable-next-line no-param-reassign
        delete obj[key]),
  );
  return obj;
}
